import { render, staticRenderFns } from "./ChangeOverTimeChartLoading.vue?vue&type=template&id=e247a58a&scoped=true&"
import script from "./ChangeOverTimeChartLoading.vue?vue&type=script&lang=js&"
export * from "./ChangeOverTimeChartLoading.vue?vue&type=script&lang=js&"
import style0 from "./ChangeOverTimeChartLoading.vue?vue&type=style&index=0&id=e247a58a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e247a58a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e247a58a')) {
      api.createRecord('e247a58a', component.options)
    } else {
      api.reload('e247a58a', component.options)
    }
    module.hot.accept("./ChangeOverTimeChartLoading.vue?vue&type=template&id=e247a58a&scoped=true&", function () {
      api.rerender('e247a58a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/change-over-time/ChangeOverTimeChartLoading.vue"
export default component.exports